const STUDIOS_REQUIRING_TEAM_NAMES = ['bnl'];

export default STUDIOS_REQUIRING_TEAM_NAMES;
